import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb, Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../routes";

export default () => {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Contribution purposes</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Contribution purposes</h4>
          <p className="mb-0">Purposes are managed per group.</p>
        </div>
      </div>

      <Row>
        <Col xs={12} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <p className="mb-0">
                Open a group ledger or Record income, then use <strong>Manage purposes</strong> to add and edit contribution purposes for that group.
              </p>
              <Button as={Link} to={Routes.Groups.path} variant="primary" className="mt-3">
                Go to Groups
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
